import React from 'react'
import useSWR from '../../hooks/useSWR'

const OpenQToolsBtn = ({ openQtools, deliveries }) => {
  const { data } = useSWR('/subject/admin/admin')

  if (!data || !data.user || !data.user.roles || !data.user.roles.includes('qtools')) return null

  return (
    <p onClick={() => openQtools(deliveries)} style={{ marginTop: 0 }} className="sub-title-text-container">
      QTools
    </p>
  )
}

export default OpenQToolsBtn
